// Insights archive cards. The build pre-renders them into the page
// (data-prerendered); this script only renders when that did not happen,
// e.g. when a page is opened straight from the source tree.
document.addEventListener("DOMContentLoaded", () => {
  const archiveEl = document.getElementById("archiveArticles");
  const cards = window.ForsytInsightsCards;
  if (!archiveEl || !cards || archiveEl.dataset.prerendered) return;

  const href = (link) => new URL(link.replace(/^\//, ""), document.baseURI).toString();
  let data = null;
  let failed = false;

  const render = () => {
    const lang = window.forsytLang || "en";
    if (failed) {
      archiveEl.innerHTML = cards.unavailable("archive", lang);
      return;
    }
    if (!data) return;
    archiveEl.innerHTML = cards.archiveCards(data.articles || [], lang, href, "scroll-reveal active");
  };

  document.addEventListener("forsyt:langchange", render);
  fetch(new URL("data/insights-index.json", document.baseURI))
    .then((r) => {
      if (!r.ok) throw new Error("Failed to load archive data.");
      return r.json();
    })
    .then((json) => {
      data = json;
      render();
    })
    .catch((error) => {
      console.error("Archive load error:", error);
      failed = true;
      render();
    });
});
